{
	"layout": {
		"symbol-sort-key": [
			"match",
			["get", "intersection_priority"],
			"High",
			5,
			"Medium High",
			4,
			"Medium",
			3,
			"Low Medium",
			2,
			"Low",
			1,
			0
		],
		"text-field": "■",
		"text-offset": [0, 0.04],
		"text-size": 16,
		"text-allow-overlap": true
	},
	"paint": {
		"text-color": [
			"match",
			["get", "intersection_priority"],
			"High",
			"#000000",
			"Medium High",
			"#ED2938",
			"Medium",
			"#FFAA1C",
			"Low Medium",
			"#FFE733",
			"Low",
			"#41C300",
			"#ddd"
		],
		"text-opacity": 0.9,
		"text-halo-color": "#555",
		"text-halo-width": 1
	}
}
